export const toRial = (value, unit) => {
  const n = Number(String(value).replace(/,/g, "")) || 0;
  return unit === "toman" ? n * 10 : n;
};

export const toDisplay = (rial, unit) => (unit === "toman" ? rial / 10 : rial);
